"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDismissNotification;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useDismissNotification() {
  return (0, _useWebChatAPIContext.default)().dismissNotification;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VEaXNtaXNzTm90aWZpY2F0aW9uIiwidXNlV2ViQ2hhdEFQSUNvbnRleHQiLCJkaXNtaXNzTm90aWZpY2F0aW9uIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlRGlzbWlzc05vdGlmaWNhdGlvbi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZURpc21pc3NOb3RpZmljYXRpb24oKTogKGlkOiBzdHJpbmcpID0+IHZvaWQge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5kaXNtaXNzTm90aWZpY2F0aW9uO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxzQkFBVCxHQUF3RDtFQUNyRSxPQUFPLElBQUFDLDZCQUFBLElBQXVCQyxtQkFBOUI7QUFDRCJ9